export default "__VITE_ASSET__DLR78xHw__"